import { field, FormRule } from "../../types";
export function validateFields(fields: field[]) {
    if (fields.length === 0) {
        return "Form needs at least one field.";
    }
    for (const field of fields) {
        if(field.field_type === "sub_form" && (!field.sub_form_id || !field.sub_form_name)){
            return "Sub Form field \"" + field.label + "\" must have a sub form selected.";
        }
        if (field.options && field.options.length === 0) {
        return `Field "${field.label || "Unnamed"}" has no options.`;
        }
    }
    return null;
}
export function validateRules(rules: FormRule[], fields: field[]) {
    for (let i = 0; i < rules.length; i++) {
        const rule = rules[i];
        const whenKeys = rule.when.map(c => c.field_key);
        for (const key of rule.then.show ?? []) {
            if (whenKeys.includes(key)) {
                return `Rule ${i + 1} Error: field "${getLabel(fields, key)}" appears in both WHEN and THEN.`;
            }
        }
    }
    const graph = new Map<number, number[]>();
    for (const rule of rules) {
        const fromKeys = rule.when.map(c => c.field_key);
        const toKeys = [
            ...(rule.then.show ?? [])
        ];
        for (const from of fromKeys) {
            if (!graph.has(from)) graph.set(from, []);
            graph.get(from)!.push(...toKeys);
        }
    }
    const visiting = new Set<number>();
    const visited = new Set<number>();
    function dfs(node: number): boolean {
        if (visiting.has(node)) return true; // cycle found
        if (visited.has(node)) return false;
        visiting.add(node);
        for (const next of graph.get(node) ?? []) {
            if (dfs(next)) return true;
        }
        visiting.delete(node);
        visited.add(node);
        return false;
    }
    for (const node of graph.keys()) {
        if (dfs(node)) {
            return `Rules Error: circular dependency detected involving field "${getLabel(fields, node)}".`;
        }
    }
    return null;
}
function getLabel(fields: field[], key: number) {
    return fields.find(f => f.field_key === key)?.label ?? `field_key=${key}`;
}
